module.exports = __webpack_public_path__ + "img/Grejanje_PELETTES.ec23044f.svg";